$.get("https://ipinfo.io/json", function (response) {
    var countries = ['AU','UK','NZ','US'];
    var country_name = '';
    if (countries.includes(response.country)) {
        switch(response.country) {
            case 'AU':
                country_name = 'AUSTRALIA';
                break;
            case 'UK':
                country_name = 'UK';
                break;
            case 'US':
                country_name = 'US';
                break;
            default:
                country_name = 'New Zealand';
        }
        $("[data-country-name]").each(function() {
            if ($(this).data('country-name') !== country_name) {
                $(this).show();
            }
        });
        $("[data-country]").text(country_name);
        $('[data-link-title]').each(function() {
            if ($(this).data('link-title') === country_name.toLowerCase()) {
                $(this).show();
            }
        });
    }
});
